module.exports = __webpack_public_path__ + "img/smart-packaging-online.f6e999c4.png";